module.exports = __webpack_public_path__ + "media/images/new-year/newyear-2-template-en-a75add23299ff05275ed8e8b0dc2f989.png";